// extracted by mini-css-extract-plugin
export default {"outerContainer":"style_outerContainer__9k0LC","animationContainer":"style_animationContainer__5x0cH"};